<template>
    <button
        type="button"
        class="score-prediction-promotion-badge"
        v-bind:class="gaClass"
        data-testid="score-prediction-promotion-badge"
        v-on:click.stop="openEventPage"
    >
        <SboIcon
            name="system:gift"
            size="12"
            class="score-prediction-promotion-badge-icon"
        />
        <span class="score-prediction-promotion-badge-label">{{ i18n.t('score_prediction_badge_label') }}</span>
    </button>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import { useScorePredictionPromotion } from '@/libraries/composables/useScorePredictionPromotion';
    import type { ScorePredictionPromotionGaLabel, ScorePredictionPromotionGaPage } from '@/libraries/composables/useScorePredictionPromotionGa';
    import { scorePredictionPromotionGaClass } from '@/libraries/composables/useScorePredictionPromotionGa';
    import { i18n } from '@/libraries/i18n';

    const props = defineProps<{
        gaPage: ScorePredictionPromotionGaPage;
        gaLabel: ScorePredictionPromotionGaLabel;
    }>();

    const { openEventPage } = useScorePredictionPromotion();

    const gaClass = computed(() => scorePredictionPromotionGaClass(props.gaPage, props.gaLabel));
</script>

<style lang="scss" scoped>
    @import "@/scss/components/promotion/scorePredictionPromotionBadge";
</style>
